export default __webpack_public_path__ + "static/buku-edu-online-2a13906ef218a992a665e5b55a61b839.jpeg";